import React, { useContext, useState, useEffect } from "react";
import {
  Button,
  TextField,
  Typography,
  Container,
  Grid,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Box,
  IconButton,
  FormHelperText,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DescriptionIcon from "@mui/icons-material/Description";
import { useFormik } from "formik";
import * as Yup from "yup";
import { DataContext } from "../../context/dataprovider.js";
import usePaymentRequest from "../../components/paymentmethods.js";
import {
  handleFileChanges,
  handleRemoveFile,
} from "../../components/helperfunctions.js";

const PaymentRequest = ({ initialFormData, handleClose }) => {
  // console.log(`initial Form Data is ${JSON.stringify(initialFormData)}`);
  const [netPayable, setNetPayableState] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const { userData, role, statusDef } = useContext(DataContext);
  const handleAmountChange = (e) => {
    const { name, value } = e.target;

    // Convert all relevant fields to numbers safely
    const rawAmount =
      name === "amount" ? Number(value) : Number(formik.values.amount) || 0;

    const otherDeductions =
      Number(
        name === "other_deductions" ? value : formik.values.other_deductions
      ) || 0;

    const tdsValue =
      Number(name === "tds_value" ? value : formik.values.tds_value) || 0;

    const tdsType = name === "tds_type" ? value : formik.values.tds_type;
    const tdsApplicable =
      name === "tds_applicable" ? value : formik.values.tds_applicable;

    // Initialize netPayable from amount
    let netPayable = rawAmount;

    // Apply deduction logic
    if (tdsApplicable === "yes") {
      if (tdsType === "amount" && !isNaN(tdsValue)) {
        netPayable = rawAmount - tdsValue - otherDeductions;
      } else if (tdsType === "percentage" && !isNaN(tdsValue)) {
        netPayable = rawAmount - (rawAmount * tdsValue) / 100 - otherDeductions;
      } else {
        netPayable = rawAmount - otherDeductions;
      }
    } else {
      netPayable = rawAmount - otherDeductions;
    }

    // Prevent negative or NaN values
    if (isNaN(netPayable)) {
      netPayable = 0;
    }

    // Round to 2 decimal places and convert to number again to avoid string issue
    const finalNetPayable = parseFloat(netPayable.toFixed(2));

    // Set Formik values
    formik.setFieldValue(name, value);
    formik.setFieldValue("net_payable", finalNetPayable);
  };

  const { updatePayment, createPayment, isLoading, iserror } =
    usePaymentRequest();
  useEffect(() => {
    if (initialFormData) {
      const existingUrls = Array.isArray(initialFormData.pr_attachments)
        ? initialFormData.pr_attachments.map((url) => ({
            url, // Keep the URL as-is
            name: url.split("/").pop(), // Extract file name from URL
            isImage: /\.(jpg|jpeg|png|gif)$/i.test(url), // Determine if it's an image
            source: "preloaded", // Indicate that it's preloaded
          }))
        : [];
      setSelectedFiles(existingUrls); // Load preloaded files/URLs into the state
    }
  }, [initialFormData]);
  // for creating transaction
  const initialValues = initialFormData || {
    project_id: "",
    amount: "",
    payment_type: "Site Expenditure",
    sender_name: userData?.name || "",
    sender_id: userData?.id || "",
    pr_remarks: "",
    other_pr_remarks: "",
    financial_remarks: "",
    status: "Submitted",
    rejectedcause: "",
    acc_bills: [],
    pr_receipts: [],
    pr_attachments: [],
    accountnumber: "",
    ifsc: "",
    ponumber: "",
    po_date: null,
    vendorname: "",
    paytype: "",
    upinumber: "",
    Branch: "",
    tds_applicable: "",
    tds_type: "",
    tds_value: "",
    other_deductions: 0,
    account_head: "",
    invoice_no: "",
    inv_date: null,
    paymentdone_date: null,
    pi_date: null,
    pi_invoice_no: "",
    net_payable: 0,
  };
  const createValidationSchema = (userData) => {
    const isFinancialAdmin =
      userData?.role === "financialadmin" || userData?.role === "superadmin";

    const baseSchema = {
      project_id: Yup.string().required("Project is required"),
      amount: Yup.number().required("Amount is required"),
      pr_remarks: Yup.string().required("PR Remarks is required"),
      accountnumber: Yup.string().required("Account Number is required"),
      ifsc: Yup.string().required("IFSC is required"),
      ponumber: Yup.string().required("PO Number is required"),
      vendorname: Yup.string().required("Vendor Name is required"),
      other_pr_remarks: Yup.string().when("pr_remarks", {
        is: "Other's",
        then: (schema) => schema.required("Remarks is required"),
        otherwise: (schema) => schema,
      }),
    };

    // Add conditional fields only if user is financial admin
    if (isFinancialAdmin) {
      baseSchema.financial_remarks = Yup.string().required(
        "Financial Remarks is required"
      );
      baseSchema.tds_applicable = Yup.string().required(
        "TDS Applicable is required"
      );
      baseSchema.account_head = Yup.string().required(
        "Account Head is required"
      );
    }

    return Yup.object(baseSchema);
  };
  const formik = useFormik({
    initialValues,
    // validationSchema: Yup.object({
    //   project_id: Yup.string().required("Project is required"),
    //   amount: Yup.number().required("Amount is required"),
    //   pr_remarks: Yup.string().required("PR Remarks is required"),

    //   // Alternative approach using when() with proper context
    //   financial_remarks: Yup.string().when('$userData', {
    //     is: (userData) => userData?.role === "financialadmin" || userData?.role === "superadmin",
    //     then: (schema) => schema.required("Financial Remarks is required"),
    //     otherwise: (schema) => schema,
    //   }),

    //   tds_applicable: Yup.string().when('$userData', {
    //     is: (userData) => userData?.role === "financialadmin" || userData?.role === "superadmin",
    //     then: (schema) => schema.required("TDS Applicable is required"),
    //     otherwise: (schema) => schema,
    //   }).nullable(), // Add this

    //   account_head: Yup.string().when('$userData', {
    //     is: (userData) => userData?.role === "financialadmin" || userData?.role === "superadmin",
    //     then: (schema) => schema.required("Account Head is required"),
    //     otherwise: (schema) => schema,
    //   }).nullable(), // Add this

    //   accountnumber: Yup.string().required("Account Number is required"),
    //   ifsc: Yup.string().required("IFSC is required"),
    //   ponumber: Yup.string().required("PO Number is required"),
    //   vendorname: Yup.string().required("Vendor Name is required"),

    //   other_pr_remarks: Yup.string().when("pr_remarks", {
    //     is: "Other's",
    //     then: (schema) => schema.required("Remarks is required"),
    //     otherwise: (schema) => schema,
    //   }),
    // }),
    // Pass userData as context
    validationSchema: createValidationSchema(userData),
    context: {
      userData: userData,
    },
    validate: (values) => {
      Object.keys(values).forEach((key) => {
        if (typeof values[key] === "string") {
          values[key] = values[key].trim();
        }
      });
      return {};
    },
    validateOnChange: true,
    validateOnBlur: true,
    validateOnMount: true, // Enable to check initial validation
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      const formData = new FormData();
      selectedFiles.forEach((file) => {
        if (file.source === "new") {
          formData.append("files", file.file);
        } else {
          formData.append("files", file.url);
        }
      });
      Object.keys(values).forEach((key) => {
        const value = values[key];
        if (Array.isArray(value)) {
          // Serialize arrays before appending
          if (value.length > 0) {
            formData.append(key, JSON.stringify(value));
          }
        } else {
          formData.append(key, value || null);
        }
      });
      // add to form data if not present in form data
      // sendername
      if (!formData.has("sender_name")) {
        formData.append("sender_name", userData.name);
      }
      // senderid
      if (!formData.has("sender_id")) {
        formData.append("sender_id", userData.email);
      }
      // payment type
      if (!formData.has("payment_type")) {
        formData.append("payment_type", "Site Expenditure");
      }
      // status
      if (!formData.has("status")) {
        formData.append("status", "Submitted");
      }
      // rejectedcause
      if (!formData.has("rejectedcause")) {
        formData.append("rejectedcause", "");
      }
      // acc_bills
      if (!formData.has("acc_bills")) {
        formData.append("acc_bills", JSON.stringify([]));
      }
      // pr_receipts
      if (!formData.has("pr_receipts")) {
        formData.append("pr_receipts", JSON.stringify([]));
      }
      //role
      if (!formData.has("role")) {
        formData.append("role", userData.role);
      }

      if (values.pr_remarks !== "Other's") {
        formData.delete("other_pr_remarks");
      } else {
        formData.set("pr_remarks", values.other_pr_remarks);
        formData.delete("other_pr_remarks");
      }
      if (
        userData.role !== "financialadmin" &&
        userData.role !== "superadmin"
      ) {
        formData.delete("financial_remarks");
      }
      if (userData.role === "user" || userData.role === "admin") {
        formData.delete("tds_applicable");
        formData.delete("tds_type");
        formData.delete("tds_value");
        formData.delete("other_deductions");
        formData.delete("account_head");
        formData.delete("invoice_no");
        formData.delete("inv_date");
        formData.delete("pi_invoice_no");
        formData.delete("pi_date");
        formData.delete("paymentdone_Date");
      }

      if (!formData.has("payment_type")) {
        formData.append("payment_type", "Site Expenditure");
      }
      try {
        if (initialFormData && initialFormData.trans_id) {
          // console.log("update");
          const response = await updatePayment.mutateAsync({
            id: initialFormData.trans_id,
            data: formData,
          });
          // console.log(response);
        } else {
          // console.log("create");
          const response = await createPayment.mutateAsync(formData);
          // console.log(response);
        }
        resetForm();
        setSelectedFiles([]);
        handleClose();
      } catch (error) {
        console.error(error);
      } finally {
        setSubmitting(false);
      }
    },
  });
  // useEffect(() => {
  //   console.log("userData.role:", userData?.role);
  //   console.log("role object:", role);
  //   console.log("Validation errors:", formik.errors);
  //   console.log("Is form valid?", formik.isValid);
  //   console.log("Formik values:", formik.values);
  // }, [formik.errors, formik.isValid, formik.values, userData?.role, role]);

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "100%",
        overflowX: "hidden",
        padding: { xs: 2, sm: 3 },
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h4"
          gutterBottom
          sx={{
            fontSize: { xs: "1.5rem", sm: "2rem" },
            marginBottom: { xs: 2, sm: 3 },
          }}
        >
          Site Expenditures
        </Typography>

        <Box
          component="form"
          onSubmit={formik.handleSubmit}
          sx={{
            mt: { xs: 2, sm: 3 },
            "& .MuiFormControl-root": { m: 0 },
          }}
        >
          <Grid container spacing={{ xs: 2, sm: 3 }}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Project</InputLabel>
                <Select
                  name="project_id"
                  required
                  value={formik.values.project_id || ""}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={
                    initialFormData?.status !== undefined &&
                    ![
                      statusDef.fail,
                      statusDef.initial,
                      statusDef.accountantDenied,
                      statusDef.financialDenied,
                      statusDef.qualityfail,
                    ].includes(initialFormData.status)
                  }
                  error={
                    formik.touched.project_id &&
                    Boolean(formik.errors.project_id)
                  }
                >
                  {/* Include formik.project_id if it's not in userData.projectId or userData doesn't exist */}
                  {formik.values.project_id &&
                    formik.values.project_id !== "" &&
                    (!userData?.projectId ||
                      !userData.projectId.includes(
                        formik.values.project_id
                      )) && (
                      <MenuItem value={formik.values.project_id}>
                        {formik.values.project_id}
                      </MenuItem>
                    )}
                  {userData?.projectId?.map((project, index) => (
                    <MenuItem key={index} value={project}>
                      {project}
                    </MenuItem>
                  ))}
                </Select>
                {formik.touched.project_id && formik.errors.project_id && (
                  <FormHelperText error>
                    {formik.errors.project_id}
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="amount"
                label="Amount"
                required
                value={formik.values.amount}
                onChange={handleAmountChange}
                onBlur={formik.handleBlur}
                error={formik.touched.amount && Boolean(formik.errors.amount)}
                helperText={formik.touched.amount && formik.errors.amount}
                fullWidth
                disabled={
                  initialFormData?.status !== undefined &&
                  ![
                    statusDef.phase1,
                    statusDef.phase2,
                    statusDef.fail,
                    statusDef.initial,
                    statusDef.accountantDenied,
                    statusDef.financialDenied,
                    statusDef.qualityfail,
                  ].includes(initialFormData.status)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="ponumber"
                label="PO Number"
                required
                value={formik.values.ponumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.ponumber && Boolean(formik.errors.ponumber)
                }
                helperText={formik.touched.ponumber && formik.errors.ponumber}
                fullWidth
                disabled={
                  initialFormData?.status !== undefined &&
                  ![
                    statusDef.fail,
                    statusDef.initial,
                    statusDef.accountantDenied,
                    statusDef.financialDenied,
                    statusDef.qualityfail,
                  ].includes(initialFormData.status)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="po_date"
                label="PO Date"
                type="date"
                value={
                  formik.values.po_date
                    ? formik.values.po_date.slice(0, 10)
                    : ""
                }
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                name="vendorname"
                label="Vendor Name"
                value={formik.values.vendorname}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.vendorname && Boolean(formik.errors.vendorname)
                }
                helperText={
                  formik.touched.vendorname && formik.errors.vendorname
                }
                disabled={
                  initialFormData?.status !== undefined &&
                  ![
                    statusDef.fail,
                    statusDef.initial,
                    statusDef.accountantDenied,
                    statusDef.financialDenied,
                    statusDef.qualityfail,
                  ].includes(initialFormData.status)
                }
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                name="accountnumber"
                label="Account Number"
                value={formik.values.accountnumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.accountnumber &&
                  Boolean(formik.errors.accountnumber)
                }
                helperText={
                  formik.touched.accountnumber && formik.errors.accountnumber
                }
                disabled={
                  initialFormData?.status !== undefined &&
                  ![
                    statusDef.fail,
                    statusDef.initial,
                    statusDef.accountantDenied,
                    statusDef.financialDenied,
                    statusDef.qualityfail,
                  ].includes(initialFormData.status)
                }
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                name="ifsc"
                label="IFSC"
                value={formik.values.ifsc}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.ifsc && Boolean(formik.errors.ifsc)}
                helperText={formik.touched.ifsc && formik.errors.ifsc}
                fullWidth
                disabled={
                  initialFormData?.status !== undefined &&
                  ![
                    statusDef.fail,
                    statusDef.initial,
                    statusDef.accountantDenied,
                    statusDef.financialDenied,
                    statusDef.qualityfail,
                  ].includes(initialFormData.status)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="Branch"
                label="Enter Branch Name"
                value={formik.values.Branch}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.Branch && Boolean(formik.errors.Branch)}
                helperText={formik.touched.Branch && formik.errors.Branch}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>PR Remarks</InputLabel>
                <Select
                  required
                  name="pr_remarks"
                  value={formik.values.pr_remarks || ""}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.pr_remarks &&
                    Boolean(formik.errors.pr_remarks)
                  }
                  disabled={
                    initialFormData?.status !== undefined &&
                    ![
                      statusDef.fail,
                      statusDef.initial,
                      statusDef.accountantDenied,
                      statusDef.financialDenied,
                      statusDef.qualityfail,
                    ].includes(initialFormData.status)
                  }
                >
                  {/* Include formik.pr_remarks if it's not in userData.remarks and not an empty string */}
                  {formik.values.pr_remarks &&
                    formik.values.pr_remarks !== "" &&
                    !userData?.remarks?.includes(formik.values.pr_remarks) && (
                      <MenuItem value={formik.values.pr_remarks}>
                        {formik.values.pr_remarks}
                      </MenuItem>
                    )}
                  {userData?.remarks?.map((reason, index) => (
                    <MenuItem key={index} value={reason}>
                      {reason}
                    </MenuItem>
                  ))}
                </Select>
                {formik.touched.pr_remarks && formik.errors.pr_remarks && (
                  <FormHelperText error>
                    {formik.errors.pr_remarks}
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>

            {formik.values.pr_remarks === "Other's" && (
              <Grid item xs={12}>
                <TextField
                  name="other_pr_remarks"
                  label="Enter Remarks"
                  value={formik.values.other_pr_remarks}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.other_pr_remarks &&
                    Boolean(formik.errors.other_pr_remarks)
                  }
                  helperText={
                    formik.touched.other_pr_remarks &&
                    formik.errors.other_pr_remarks
                  }
                  fullWidth
                  disabled={
                    initialFormData?.status !== undefined &&
                    ![
                      statusDef.fail,
                      statusDef.initial,
                      statusDef.accountantDenied,
                      statusDef.financialDenied,
                      statusDef.qualityfail,
                    ].includes(initialFormData.status)
                  }
                />
              </Grid>
            )}

            {(userData.role === role.roles_3 ||
              userData.role === role.roles_4 ||
              userData.role === role.roles_5) && (
              <>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel id="tds-applicable-label">
                      TDS Applicable
                    </InputLabel>
                    <Select
                      labelId="tds-applicable-label"
                      name="tds_applicable"
                      value={formik.values.tds_applicable}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.tds_applicable &&
                        Boolean(formik.errors.tds_applicable)
                      }
                      disabled={
                        ![role.roles_3, role.roles_4, role.roles_5].includes(
                          userData?.role
                        ) ||
                        ([role.roles_3, role.roles_4, role.roles_5].includes(
                          userData?.role
                        ) &&
                          initialFormData?.status !== undefined &&
                          ![
                            statusDef.fail,
                            statusDef.initial,
                            statusDef.phase1,
                          ].includes(initialFormData.status) &&
                          !(
                            [role.roles_3, role.roles_4, role.roles_5].includes(
                              userData?.role
                            ) && initialFormData?.status === undefined
                          ))
                      }
                    >
                      <MenuItem value="yes">Yes</MenuItem>
                      <MenuItem value="no">No</MenuItem>
                    </Select>
                    {formik.touched.tds_applicable &&
                      formik.errors.tds_applicable && (
                        <FormHelperText error>
                          {formik.errors.tds_applicable}
                        </FormHelperText>
                      )}
                  </FormControl>
                </Grid>

                {formik.values.tds_applicable === "yes" && (
                  <>
                    <Grid item xs={12} sm={6}>
                      <FormControl component="fieldset">
                        <FormLabel component="legend">TDS Type</FormLabel>
                        <RadioGroup
                          row
                          name="tds_type"
                          value={formik.values.tds_type}
                          onChange={handleAmountChange}
                        >
                          <FormControlLabel
                            value="percentage"
                            control={
                              <Radio
                                disabled={
                                  ![
                                    role.roles_3,
                                    role.roles_4,
                                    role.roles_5,
                                  ].includes(userData?.role) ||
                                  ([
                                    role.roles_3,
                                    role.roles_4,
                                    role.roles_5,
                                  ].includes(userData?.role) &&
                                    initialFormData?.status !== undefined &&
                                    ![
                                      statusDef.fail,
                                      statusDef.initial,
                                      statusDef.phase1,
                                    ].includes(initialFormData.status) &&
                                    !(
                                      [
                                        role.roles_3,
                                        role.roles_4,
                                        role.roles_5,
                                      ].includes(userData?.role) &&
                                      initialFormData?.status === undefined
                                    ))
                                }
                              />
                            }
                            label="Percentage"
                          />
                          <FormControlLabel
                            value="amount"
                            control={
                              <Radio
                                disabled={
                                  ![
                                    role.roles_3,
                                    role.roles_4,
                                    role.roles_5,
                                  ].includes(userData?.role) ||
                                  ([
                                    role.roles_3,
                                    role.roles_4,
                                    role.roles_5,
                                  ].includes(userData?.role) &&
                                    initialFormData?.status !== undefined &&
                                    ![
                                      statusDef.fail,
                                      statusDef.initial,
                                      statusDef.phase1,
                                    ].includes(initialFormData.status) &&
                                    !(
                                      [
                                        role.roles_3,
                                        role.roles_4,
                                        role.roles_5,
                                      ].includes(userData?.role) &&
                                      initialFormData?.status === undefined
                                    ))
                                }
                              />
                            }
                            label="Amount"
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        name="tds_value"
                        label={
                          formik.values.tds_type === "percentage"
                            ? "TDS (%)"
                            : "TDS Amount"
                        }
                        type="number"
                        value={formik.values.tds_value}
                        onChange={handleAmountChange}
                        onBlur={formik.handleBlur}
                        disabled={
                          ![role.roles_3, role.roles_4, role.roles_5].includes(
                            userData?.role
                          ) ||
                          ([role.roles_3, role.roles_4, role.roles_5].includes(
                            userData?.role
                          ) &&
                            initialFormData?.status !== undefined &&
                            ![
                              statusDef.fail,
                              statusDef.initial,
                              statusDef.phase1,
                            ].includes(initialFormData.status) &&
                            !(
                              [
                                role.roles_3,
                                role.roles_4,
                                role.roles_5,
                              ].includes(userData?.role) &&
                              initialFormData?.status === undefined
                            ))
                        }
                        error={
                          formik.touched.tds_value &&
                          Boolean(formik.errors.tds_value)
                        }
                        helperText={
                          formik.touched.tds_value && formik.errors.tds_value
                        }
                        fullWidth
                        InputProps={{ inputProps: { min: 0 } }}
                      />
                    </Grid>
                  </>
                )}

                <Grid item xs={12} sm={6}>
                  <TextField
                    name="other_deductions"
                    label="Other Deductions"
                    type="number"
                    value={formik.values.other_deductions}
                    onChange={handleAmountChange}
                    onBlur={formik.handleBlur}
                    disabled={
                      ![role.roles_3, role.roles_4, role.roles_5].includes(
                        userData?.role
                      ) ||
                      ([role.roles_3, role.roles_4, role.roles_5].includes(
                        userData?.role
                      ) &&
                        initialFormData?.status !== undefined &&
                        ![
                          statusDef.fail,
                          statusDef.initial,
                          statusDef.phase1,
                        ].includes(initialFormData.status) &&
                        !(
                          [role.roles_3, role.roles_4, role.roles_5].includes(
                            userData?.role
                          ) && initialFormData?.status === undefined
                        ))
                    }
                    error={
                      formik.touched.other_deductions &&
                      Boolean(formik.errors.other_deductions)
                    }
                    helperText={
                      formik.touched.other_deductions &&
                      formik.errors.other_deductions
                    }
                    fullWidth
                    InputProps={{ inputProps: { min: 0 } }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Net Payable"
                    name="net_payable"
                    value={formik.values.net_payable || netPayable}
                    onBlur={formik.handleBlur}
                    disabled
                    fullWidth
                    margin="normal"
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    required
                    name="financial_remarks"
                    label="Financial Remarks"
                    value={formik.values.financial_remarks}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={
                      ![role.roles_3, role.roles_5].includes(userData?.role) ||
                      ([role.roles_3, role.roles_5].includes(userData?.role) &&
                        initialFormData?.status !== undefined &&
                        ![
                          statusDef.fail,
                          statusDef.initial,
                          statusDef.phase1,
                        ].includes(initialFormData.status))
                    }
                    error={
                      formik.touched.financial_remarks &&
                      Boolean(formik.errors.financial_remarks)
                    }
                    helperText={
                      formik.touched.financial_remarks &&
                      formik.errors.financial_remarks
                    }
                    fullWidth
                  />
                </Grid>
              </>
            )}

            {(userData.role === role.roles_3 ||
              userData.role === role.roles_4 ||
              userData.role === role.roles_5) && (
              <>
                <Grid item xs={12} sm={6}>
                  <TextField
                    name="invoice_no"
                    label="Invoice No"
                    value={formik.values.invoice_no}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    name="inv_date"
                    label="Inv Date"
                    type="date"
                    value={
                      formik.values.inv_date
                        ? formik.values.inv_date.slice(0, 10)
                        : ""
                    }
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    name="pi_invoice_no"
                    label="Proforma Inv No"
                    value={formik.values.pi_invoice_no}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    name="pi_date"
                    label="PI Date"
                    type="date"
                    value={
                      formik.values.pi_date
                        ? formik.values.pi_date.slice(0, 10)
                        : ""
                    }
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    name="account_head"
                    label="Account Head"
                    value={formik.values.account_head}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    fullWidth
                    disabled={
                      initialFormData?.status !== undefined &&
                      ![
                        statusDef.fail,
                        statusDef.initial,
                        statusDef.phase1,
                      ].includes(initialFormData.status)
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    name="paymentdone_date"
                    label="Payment Done Date"
                    type="date"
                    value={
                      formik.values.paymentdone_date
                        ? new Date(
                            formik.values.paymentdone_date
                          ).toLocaleDateString("en-CA")
                        : ""
                    }
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    disabled={
                      ![
                        statusDef.phase4,
                        statusDef.phase5,
                        statusDef.qualityfail,
                      ].includes(initialFormData?.status)
                    }
                  />
                </Grid>
              </>
            )}

            {Array.isArray(selectedFiles) && selectedFiles.length > 0 && (
              <Box mt={2}>
                <Typography variant="h6">Selected Files:</Typography>
                <Box display="flex" flexWrap="wrap">
                  {selectedFiles.map((item, index) => {
                    const previewUrl =
                      item.source === "new" && item.file
                        ? URL.createObjectURL(item.file) // Create preview for new files
                        : item.url; // Use the preloaded URL directly

                    return (
                      <Box
                        position="relative"
                        key={index}
                        marginRight="10px"
                        marginBottom="10px"
                      >
                        {item.isImage ? (
                          <img
                            src={previewUrl}
                            alt={item.name}
                            style={{
                              width: "100px",
                              height: "100px",
                              objectFit: "cover",
                            }}
                          />
                        ) : (
                          <a
                            href={previewUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              width: "100px",
                              height: "100px",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              border: "1px dashed gray",
                              textDecoration: "none",
                              color: "black",
                            }}
                          >
                            <DescriptionIcon
                              style={{ fontSize: "40px", color: "gray" }}
                            />
                            <span
                              style={{ marginTop: "5px", fontSize: "14px" }}
                            >
                              View Document
                            </span>
                          </a>
                        )}
                        <IconButton
                          onClick={(event) =>
                            handleRemoveFile(setSelectedFiles, item.name)
                          }
                          style={{
                            position: "absolute",
                            top: 0,
                            right: 0,
                            color: "red",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            )}
            <Grid item xs={12}>
              <TextField
                type="file"
                name="pr_attachments"
                label="Pick Files"
                //pass event , state and setter function to onchange
                onChange={(event) =>
                  handleFileChanges(event, selectedFiles, setSelectedFiles)
                }
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{ multiple: true }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    paddingY: 1,
                  },
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Button
                variant="contained"
                type="submit"
                fullWidth
                disabled={formik.isSubmitting || !formik.isValid}
                sx={{
                  mt: { xs: 2, sm: 3 },
                  py: { xs: 1.5, sm: 2 },
                }}
              >
                {formik.isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default PaymentRequest;
